import styles from "./ReminderFormItems.module.scss";

export function ReminderFormItems(): JSX.Element {
    return <div className={styles.infoSpan}>This will create a Reminder task on the agent desktop.</div>;
}
